import { AxiosResponse } from "axios";

import API from "../api";
import { Roles } from "../models/user";
import { Group } from "Models/group";

const ROUTE_NAME = "roles";

const RoleService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Roles[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async getAllIncludeGroups(options?: any): Promise<AxiosResponse<Roles[]>> {
    return await API.get(`/${ROUTE_NAME}/list/inclule-groups`, { params: options });
  },
  async create(role: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, role);
  },
  async update(id: number, role: any): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, role);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async duplicate(id: number): Promise<AxiosResponse<Roles>> {
    return await API.post(`/${ROUTE_NAME}/duplicate/${id}`);
  },
  async getGroupsInAccessRule(option: any): Promise<AxiosResponse<Group[]>> {
    return await API.post(`/groups-in-access-rule`, option);
  },
  async bulkAssign(payload: any): Promise<AxiosResponse<any>> {
    return await API.post(`/permissions/bulk-assign`, payload);
  },
  async getPermissionsByRoleId(roleId: number): Promise<AxiosResponse<any>> {
    return await API.get(`/permissions/get-by-role`, { params: {roleId} });
  },
};

export default RoleService;
